import INFO_BANKS from 'util/_vietnam_banks'
import DATA_ADDRESS from "util/_data.json"
import { CREATE_TEACHER_GENDER, TAB_CREATE_TEACHER_EDIT } from '../interfaces/constant'

export const useCreateTeacherInitialState = {
  information: {
    userName: {
      value: '',
      status: false,
      message: ''
    },
    schoolName: {
      value: '',
      status: false,
      message: ''
    },
    phone: {
      value: '',
      status: false,
      message: ''
    },
    email: {
      value: '',
      status: false,
      message: ''
    },
    name: {
      value: '',
      status: false,
      message: ''
    },
    lastName: {
      value: '',
      status: false,
      message: ''
    },
    birthdate: {
      value: '',
      status: false,
      message: '',
      trigger: false,
    },
    identify: {
      value: '',
      status: false,
      message: ''
    },
    identityFront: {
      value: '',
    },
    identityBack: {
      value: '',
    },
    contract: {
      value: '',
    },
    gender: {
      value: CREATE_TEACHER_GENDER[0],
      status: false,
      message: '',
      activeValue: CREATE_TEACHER_GENDER[0]
    },
    province: {
      value: '',
      list: DATA_ADDRESS,
      listOrigin: DATA_ADDRESS
    },
    address: {
      value: '',
      status: false,
      message: ''
    },
    password: {
      value: '',
      status: false,
      message: ''
    },
    statusPerson: {
      value: {id: 1, title: 'Đang hoạt động', value: 'active'},
      status: false,
      message: ''
    },
    accountNumber: {
      value: '',
      status: false,
      message: ''
    },
    commission: {
      value: '',
      status: false,
      message: ''
    },
    accountOwner: {
      value: '',
      status: false,
      message: ''
    },
    bankName: {
      value: '',
      status: '',
      list: INFO_BANKS,
      listOrigin: INFO_BANKS,
      keyword: ''
    },
    avatar: {
      value: '',
    },
    detail: null
  },
  tab: {
    list: TAB_CREATE_TEACHER_EDIT,
    activeTab: TAB_CREATE_TEACHER_EDIT[0]
  },
  productTab: {
    filter: {
      search: {
        value: null,
        active: null
      },
      status: {
        activeValue: null,
        value: null,
      },
      category: {
        list: [],
        listOrigin: [],
        activeValue: null,
        value: null,
        keyword: '',
      },
    },
    table: {
      display: {
        list: [],
        listDefault: [],
        loading: true,
      },
      selected: {
        list: [],
      },
      detail: {
        id: null,
        active: null,
        list: [],
      },
      pagination: {
        active: 0,
        amount: 20,
        total: 0,
        totalItems: 0,
      },
    },
    modalProduct: {
      show: false,
      filter: {
        search: {
          value: null,
          active: null
        },
        category: {
          list: [],
          listOrigin: [],
          activeValue: null,
          value: null,
          keyword: '',
        },
      },
      table: {
        display: {
          list: [],
          listDefault: [],
          loading: true,
        },
        detail: {
          id: null,
          active: null,
          list: [],
        },
        selected: {
          list: [],
        },
        pagination: {
          active: 0,
          amount: 200,
          total: 0,
          totalItems: 0,
        },
      },
    }
  },
  table: {
    display: {
      list: [],
      listDefault: [],
      loading: true,
    },
    detail: {
      id: null,
      active: null,
      list: [],
    },
    pagination: {
      active: 0,
      amount: 20,
      total: 0,
      totalItems: 0,
    },
  },
  deleteConfirm: {
    open: false,
    value: '',
    status: false,
    message: ''
  },
  commission: {
    list: [],
    loading: true,
  }
}